export default {
  root: {
    flexWrap: "wrap",
    backgroundColor: "transparent",
  },
};
